// extracted by mini-css-extract-plugin
module.exports = {"passwordValidator":"MigrateStaffAccountPassword_passwordValidator__2lsUs","resetPasswordCTA":"MigrateStaffAccountPassword_resetPasswordCTA__3kkge"};